export default __webpack_public_path__ + "static/logo-fd3d61e35cfa6ed54ef5c8eeaa75831f.webp";